<template>
    <div style="display: flex;flex-direction: row;">
        <div style="width: 30%;">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>目录预览</span>
                    <el-button style="float: right; padding: 3px 0" type="text" @click="getTree()">刷新目录树</el-button>
                </div>

                <el-tree :data="treeData" node-key="id" default-expand-all :expand-on-click-node="false">
                    <template #default="{ node, data }">
                        <span class="custom-tree-node">
                            <span>{{ node.label }}</span>
                        </span>
                    </template>
                </el-tree>
            </el-card>

        </div>
        <div style="width: 70%;">
            <el-button @click="catalogAdd()">添加目录</el-button>
            <div>
                <el-input v-model="searchTitle" size="mini" placeholder="输入关键字搜索" style="width: 200px;" />
                <el-button type="primary" :icon="Search" @click="getCatalogList()">搜索</el-button>
            </div>
            <el-scrollbar max-height="800px">
                <el-table v-loading="loading" :data="formattedItems" style="width: 100%">
                    <el-table-column fixed prop="id" label="目录id" width="150" />
                    <el-table-column prop="title" label="目录名称" width="120" />
                    <el-table-column prop="levels" label="层级" width="120" />
                    <el-table-column prop="parentId" label="父节点id" width="120" />
                    <el-table-column prop="time" label="创建时间" width="120" />
                    <el-table-column fixed="right" label="操作" width="120">
                        <template v-slot="scope"><el-button link type="primary" size="small"
                                @click="handleUpdate(scope.row)">修改</el-button>
                            <el-button link type="primary" size="small" @click="handleDelete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-scrollbar>
            <el-pagination background layout="prev, pager, next" :page-size="pageSize" :current-page="currentPage"
                :total="tableData.length" style="margin: 10px 0 ;" />
        </div>
    </div>

    <el-dialog title="添加目录" v-model="dialogFormVisible">
        <el-form :model="form">
            <el-form-item label="名称" :label-width="formLabelWidth">
                <el-input v-model="form.title" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="父节点" :label-width="formLabelWidth">
                <el-select v-model="form.parentId" placeholder="请选择父节点目录">
                    <el-option v-for="item in tableData" :label="item.title" :value="item.id"> </el-option>
                </el-select>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="catalogAddSubmit()">确 定</el-button>
        </div>
    </el-dialog>

</template>

<script>
import { ElTree, ElButton, ElMessage } from 'element-plus';
const axios = require("axios");
import { inject } from 'vue'

export default {
    components: {
        ElTree,
        ElButton,
    },
    data() {
        return {
            dialogFormVisible: false,
            pageSize: 10,
            currentPage: 1,
            searchTitle: '',
            serverUrl: inject('serverUrl'),
            form: { // 添加form对象
                id: '',
                title: '',
                parentId: ''
            },
            formLabelWidth: '120px', // 添加formLabelWidth
            treeData: [],
            tableData: []
        }
    },
    computed: {
        formattedItems() {
            return this.tableData.map(item => ({
                ...item, // 保留其他属性
                time: (item.createDate.year + 1900) + "-" + (item.createDate.month + 1) + "-" + item.createDate.date + " " + item.createDate.hours + ":" + item.createDate.minutes + ":" + item.createDate.seconds, // 格式化时间
            }));
        },
    },
    mounted() {
        this.getTree()
        this.getCatalogList()

    },
    methods: {
        catalogAdd() {
            this.dialogFormVisible = true;
        },
        handleUpdate(e) {
            if (e.levels == 0) {
                ElMessage({
                    type: "warning",
                    message: "顶级目录不能修改和删除"
                })
                return;
            }
            this.form.id = e.id;
            this.form.title = e.title;
            this.form.parentId = e.parentId;
            this.dialogFormVisible = true;
        },
        async handleDelete(e) {
            if (e.levels == 0) {
                ElMessage({
                    type: "warning",
                    message: "顶级目录不能修改和删除"
                })
                return;
            }
            if (!confirm("是否删除该目录？")) {
                return;
            }
            const res = await axios.post(
                this.serverUrl + "/api/catalog/del", // 请求后端的 URL
                {
                    "id": e.id
                },
                {
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                        "Access-Control-Allow-Origin": "*", // 允许所有域名访问，或者设置为特定的域名
                        "Access-Control-Allow-Methods": "GET, POST, OPTIONS", // 允许的请求方法
                        "Access-Control-Allow-Headers": "Content-Type", // 允许的请求头
                    },
                }
            );
            if (res.data.code != "success") {

                ElMessage({
                    type: 'error',
                    message: '操作出错：' + res.data.msg,
                })

            } else {
                ElMessage({
                    type: 'success',
                    message: '操作成功',
                })
                this.getCatalogList()
            }
        },
        async catalogAddSubmit() {
            const res = await axios.post(
                this.serverUrl + "/api/catalog/save", // 请求后端的 URL
                this.form,
                {
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                        "Access-Control-Allow-Origin": "*", // 允许所有域名访问，或者设置为特定的域名
                        "Access-Control-Allow-Methods": "GET, POST, OPTIONS", // 允许的请求方法
                        "Access-Control-Allow-Headers": "Content-Type", // 允许的请求头
                    },
                }
            );
            if (res.data.code != "success") {

                ElMessage({
                    type: 'error',
                    message: '添加出错：' + res.data.msg,
                })

            } else {
                ElMessage({
                    type: 'success',
                    message: '添加成功',
                })
                this.dialogFormVisible = false;
            }
        },
        async getTree() {
            const res = await axios.post(
                this.serverUrl + "/api/catalog/tree", // 请求后端的 URL
                null,
                {
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                        "Access-Control-Allow-Origin": "*", // 允许所有域名访问，或者设置为特定的域名
                        "Access-Control-Allow-Methods": "GET, POST, OPTIONS", // 允许的请求方法
                        "Access-Control-Allow-Headers": "Content-Type", // 允许的请求头
                    },
                }
            );
            console.log('目录树', res);
            if (res.data.code == "success") {
                ElMessage({
                    type: 'success',
                    message: '目录树获取成功',
                })

                this.treeData = res.data.obj;
            } else {
                ElMessage({
                    type: 'error',
                    message: '目录树获取失败',
                })
            }
        },
        async getCatalogList() {
            const res = await axios.post(
                this.serverUrl + "/api/catalog/list", // 请求后端的 URL
                {
                    "title": this.searchTitle,
                    "limit": this.pageSize,
                    "offset": (this.currentPage - 1) * this.pageSize
                },
                {
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                        "Access-Control-Allow-Origin": "*", // 允许所有域名访问，或者设置为特定的域名
                        "Access-Control-Allow-Methods": "GET, POST, OPTIONS", // 允许的请求方法
                        "Access-Control-Allow-Headers": "Content-Type", // 允许的请求头
                    },
                }
            );
            console.log('目录列表', res);
            if (res.data.code == "success") {
                ElMessage({
                    type: 'success',
                    message: '目录列表获取成功',
                })

                this.tableData = res.data.obj
            } else {
                ElMessage({
                    type: 'error',
                    message: '目录列表获取失败',
                })
            }
        },
    },
};
</script>

<style>
.dialog-footer {
    text-align: center;
}

.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}

.box-card {
    width: 100%;
}
</style>